import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button , Chip} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen , faUserFriends , faClock} from '@fortawesome/free-solid-svg-icons'
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Link } from 'react-router-dom';

import img from '../../images/business-placeholder.png';

export default function cardJob(props){
        let data = props.data;
        let date =  data.created_at.substring(0,10);
        let time =  data.created_at.substring(11,16);
        return (
                <Container className="pt-3 pb-3">
                    <Row>
                        <Col md={2} xs={12} className="order-sm-1 order-2  text-center">
                                <img src={data.company.logo? data.company.logo.url : img} alt="company"  height="150px" width="150px" className="mb-3 rounded" />
                        </Col>
                        <Col md={8} xs={12} className="order-sm-2 order-3 text-left text-xs-center">
                            <div>
                                <h5>{data.title}</h5>
                                <p className="text-orange d-inline-block pr-2 bold  ">{data.company.name} </p>
                                <p className="text-grey d-inline-block">{date}</p>
                               { console.log(data.brif == null)}
                                {data.brif !== null ?
                                    (data.brif.length <  100)?
                                        <p> {data.brif} </p> : 
                                        <p> {data.brif?.substring(0,100)}<Link to="/" className="text-orange pl-1 underline">See More</Link></p>
                                : ''}
                            </div>
                            <Row className="pt-1 ">   
                                <Col md={3} xs={6} className="text-left text-center-sm">
                                        <FontAwesomeIcon icon={faUserFriends} size="lg" className="text-grey"/>
                                        <span className="pl-1">{data.applications_count} Applicant</span>
                                </Col>
                                <Col md={3} xs={6} className="text-left text-center-sm">
                                        <FontAwesomeIcon icon={faBoxOpen} size="lg" className="text-grey"/>
                                        <span className="pl-1">{data.questions.length} Question</span>
                                </Col>
                                {/* <Col  className="text-left text-center-sm">
                                        <FontAwesomeIcon icon={faClock} size="lg" className="text-grey"/>
                                        <span className="pl-1"> 15 Min</span>
                                </Col> */}
                                <Col xs={12} className="p-3 text-center-sm text-left">
                                    <p className="p-0 mb-2 bold" style={{fontSize : '16px'}}>Tools</p>
                                    {data.tags.map(tag=>
                                                    <Chip
                                                       className="mt-1  text-grey bg-white border "
                                                       label={tag.name}/>
                                        )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
        );
}